export default __webpack_public_path__ + "static/105-14bf7f51b42b2d5adb84122004fc5060.jpg";